<!--
  Sector calendars — the live super-admin page (reached from the company-switch page).
  The screen itself is the shared SectorCalendarsPanel the demo also mounts; this file
  loads the periods and saves what is added or removed.
-->
<template>
  <div class="sc-page">
    <div class="sc-top">
      <router-link to="/select-company" class="back"><i class="bi bi-arrow-left"></i> {{ $t('calendar.sector.back') }}</router-link>
      <h1>{{ $t('calendar.sector.title') }}</h1>
    </div>
    <p v-if="error" class="err">{{ error }}</p>
    <div v-else-if="loading" class="loading">{{ $t('calendar.sector.loading') }}</div>
    <SectorCalendarsPanel v-else :entries="entries" :today="today" :stores="stores"
                          @add="onAdd" @remove="onRemove" />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useToast } from 'vue-toastification'
import { i18n } from '@/i18n'

import SectorCalendarsPanel from '@/components/calendars/SectorCalendarsPanel.vue'
import { useLocationCalendarStore } from '@/stores/LocationCalendarStore'

const store = useLocationCalendarStore()
const toast = useToast()
const entries = ref([])
const stores = ref({})
const loading = ref(true)
const error = ref('')
const today = new Date().toISOString().slice(0, 10)

async function load() {
  try {
    const res = await store.fetchSectorCalendarsAdmin()
    entries.value = res.entries
    stores.value = res.stores
  } catch (err) {
    error.value = i18n.global.t('calendar.sector.loadFailed')
  } finally {
    loading.value = false
  }
}

async function onAdd(entry) {
  try {
    await store.addSectorPeriod(entry)
    toast.success(i18n.global.t('calendar.sector.periodSaved'))
    await load()
  } catch (err) {
    toast.error(err.message)
  }
}

async function onRemove(id) {
  if (!window.confirm(i18n.global.t('calendar.sector.confirmRemove'))) return
  try {
    await store.removeSectorPeriod(id)
    await load()
  } catch (err) {
    toast.error(err.message)
  }
}

onMounted(load)
</script>

<style scoped>
.sc-page { max-width: 980px; margin: 0 auto; padding: 20px 16px 40px; }
.sc-top { display: flex; align-items: center; gap: 14px; margin-bottom: 14px; }
.sc-top h1 { margin: 0; font-size: 1.3rem; color: #2b3a45; }
.back { display: inline-flex; gap: 6px; align-items: center; border: 1px solid #4F7EB3; color: #4F7EB3;
        padding: 5px 11px; border-radius: 8px; text-decoration: none; background: #f7fbff; }
.back:hover { background: #4F7EB3; color: #fff; }
.err { color: #C21500; }
.loading { color: #7c8894; }
</style>
